import { render, staticRenderFns } from "./idolAbnormalGoodsOrderDetail.vue?vue&type=template&id=e9ba3530&scoped=true"
import script from "./idolAbnormalGoodsOrderDetail.vue?vue&type=script&lang=ts"
export * from "./idolAbnormalGoodsOrderDetail.vue?vue&type=script&lang=ts"
import style0 from "./idolAbnormalGoodsOrderDetail.vue?vue&type=style&index=0&id=e9ba3530&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ba3530",
  null
  
)

export default component.exports